<article class="faq-page">
  <app-header [title]="'faq-overzicht-titel' | fromDictionary"></app-header>

  <div class="bg-accent header-content-bar">
    <div class="container header-content-bar__panel">
      <ul class="quick-nav position-relative z-2">
        <li class="quick-nav__prefix button">Snel naar</li>
        @for (dep of getKeys(groupedFaq$()); track $index) {
          <li class="quick-nav__item">
            <a class="button button--primary-subtle" [routerLink]="[]" [fragment]="dep | urlRewrite">
              <span class="text-truncate">
                {{ dep }}
              </span>
            </a>
          </li>
        }
      </ul>
    </div>
  </div>

  <div class="container section-inset-b pt-5 pt-lg-6">
    <ul class="d-flex flex-column gap-6">
      @for (dep of getKeys(groupedFaq$()); track $index) {
        <li>
          <app-faq-section
            [title]="dep"
            [group]="groupedFaq$()[dep]"
            [cookiePreferences]="cookiePreferences$() || undefined"
            [id]="dep | urlRewrite"
          ></app-faq-section>
        </li>
      }
    </ul>

    <!--<pre>{{ groupedFaq$() | json }}</pre>-->
  </div>
</article>
